import styled from 'styled-components'

export const WarningMessageContainer = styled.div`
  margin-top: 24px;
`
